import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-developer/compound/units";
const apiToggleSaleStatus = API_BASE_URL_ENV() + "/crm/change-unit-status";
const apiToggleStatus = API_BASE_URL_ENV() + "/sales-developer/compound/toggle-activation/Unit";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/sales-developer/compound/dropdown/Unit?status=1";
const uploadApi = API_BASE_URL_ENV() + "/sales-developer/compound/units/import"
const exportApi = API_BASE_URL_ENV() + "/sales-developer/compound/units?export=1"
const addToBuilding = API_BASE_URL_ENV() + "/sales-developer/compound/add-units-to-building"
const deleteUnits = API_BASE_URL_ENV() + "/sales-developer/compound/delete-units"

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    addToBuilding(data){
        return http.post(addToBuilding, data);
    }
    
    toggleSaleStatus(id) {
        return http.get(`${apiToggleSaleStatus}/${id}`);
    }

    toggleStatus(id) {
        return http.get(`${apiToggleStatus}/${id}`);
    }

    getDropDown = (id, sale_status) => {
        let query = null;
        if (id) {
            query= `&building_ids=${id}`;
        }  else if (sale_status) {
            query= `&sale_status=${sale_status}`;
        }
        if(query) return http.get(`${apiDropDownEndpoint}${query}`)
        else return http.get(apiDropDownEndpoint)
    }

    getDropDownCustom = (id) => {
        if (id) {
            return http.get(`${apiDropDownEndpoint}&compound_ids=${id}`)
        } else {
            return http.get(apiDropDownEndpoint)

        }
    }
    upload = (selectedFile, options) => {
        const formData = new FormData();
        formData.append("selectedFile", selectedFile);
        return http.post(uploadApi, formData, options);
    }

    getExportUrl = (active, searchWord, filterData) => {
        const obj = JSON.parse(localStorage.getItem("auth"))
        let url = `${exportApi}&token=${obj.access_token}`;

        if (active != 'all') url = url + `&status=${active === "active" ? 1 : 0}`;
        if (searchWord.trim().length) url = url + `&keyword=${searchWord}`;

        if (filterData) {
            if (!!filterData ?.unit_type_ids) url = url + `&unit_type_ids=${filterData ?.unit_type_ids}`; //?.map(item => item.value).join()
            if (!!filterData ?.compound_id) url = url + `&compound_ids=${filterData ?.compound_id}`;
            if (filterData ?.min_price) url = url + `&min_price=${filterData ?.min_price}`;
            if (filterData ?.max_price) url = url + `&max_price=${filterData ?.max_price}`;
            if (filterData ?.min_size && filterData ?.max_size) {
                url = url + `&size_range=${filterData ?.min_size}-${filterData ?.max_size}`;
            }
            else if (filterData ?.max_size) {
                url = url + `&size_range=0-${filterData ?.max_size}`
            } else if (filterData ?.min_size) {
                url = url + `&size_range=${filterData ?.min_size}-0`
            }
        }
        return url
    }
    removeMany = (ids)=>{
        return http.post(deleteUnits, ids)
    }
}
